import React from "react";

// All pages that rely on 3rd party components (other than Bootstrap) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import AuthLayout from "./layouts/Auth";
import DashboardLayout from "./layouts/Dashboard";
import WebLayout from "./layouts/Web";
import Blank from "./pages/pages/Blank";

// Auth
import Page500 from "./pages/auth/Page500";
import Page404 from "./pages/auth/Page404";
import SignIn from "./pages/auth/SignIn";
import SignUp from "./pages/auth/SignUp";
import ResetPassword from "./pages/auth/ResetPassword";
import ChooseReport from "./pages/choose-report/ChooseReport";
import GetStartDisputely from "./pages/get-start-disputely/GetStartDisputely";
import ReportAudit from "./pages/report-audit/ReportAudit";
import ReportAuditNew from "./pages/report-audit/ReportAuditNew";
import VerifyInfo from "./pages/verify-info/VerifyInfo";
import UploadDocument from "./pages/upload-document/UploadDocument";
import MailingOption from "./pages/mailing-option/MailingOption";
import TimeToMail from "./pages/time-to-mail/TimeToMail";
import Recommendation from "./pages/recommendation/Recommendation";
import Checkout from "./pages/checkout/Checkout";
import CheckoutOnboarding from "./pages/checkout/CheckoutOnboarding";
import PaymentConfirmation from "./pages/checkout/PaymentConfirmation";
import Dashboard from "./pages/dasboard/Dashboard";
import SecurityQuestions from "./pages/security-questions/SecurityQuestions";

import AuthGuard from "./components/guards/AuthGuard";
import Setting from "./pages/setting/Setting";
import CreditBuilder from "./pages/creditbuilder/CreditBuilder";
import Documents from "./pages/documents/Documents";
import EnhanceDispute from "./pages/enhance_dispute/EnhanceDispute";
import EnhanceDisputeOnboarding from "./pages/enhance_dispute/EnhanceDisputeOnboarding";
import CreditReport from "./pages/credit_report/CreditReport";
import DisputeCenter from "./pages/dispute_center/DisputeCenter";
import CreditAudit from "./pages/credit_audit/CreditAudit";
import AddDocument from "./pages/documents/AddDocument";

import Background from "./pages/credit_audit/bg-credit-audit.png";
import { Parallax } from "react-parallax";
import AllNotification from "./pages/notification/AllNotification";
import HelpDesk from "./pages/help/HelpDesk";
import PrintJobs from "./pages/print-jobs/PrintJobs";
import EnhanceDisputesPlan from "./pages/enhance_dispute/EnhanceDisputesPlan";

const routes = [
  {
    path: 'pages',
    element: <DashboardLayout />,
    children: [
      {
        path: 'blank',
        element: <Blank />,
      },
    ],
  },
  {
    path: '/choose-report',
    element: (
      <AuthGuard>
        <WebLayout showNav={false} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/choose-report/',
        element: <ChooseReport />,
      },
    ],
  },
  {
    path: '/get-start-disputely',
    element: (
      <AuthGuard>
        <WebLayout showNav={false} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/get-start-disputely/',
        element: <GetStartDisputely gotoDashboard={false} />,
      },
    ],
  },
  {
    path: '/start-here',
    element: (
      <AuthGuard>
        <WebLayout showNav={false} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/start-here/',
        element: <GetStartDisputely gotoDashboard={true} />,
      },
    ],
  },
  {
    path: '/report-audit',
    element: (
      <AuthGuard>
        <WebLayout showNav={false} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/report-audit/',
        element: <ReportAuditNew redirectDashboard={false} />,
      },
    ],
  },
  {
    path: '/report-audit-round',
    element: (
      <AuthGuard>
        <WebLayout showNav={true} children={<ReportAuditNew redirectDashboard={true} />} />
      </AuthGuard>
    )
  },
  {
    path: '/verify-info',
    element: (
      <AuthGuard>
        <WebLayout showNav={false} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/verify-info/',
        element: <VerifyInfo />,
      },
    ],
  },
  {
    path: '/upload-document',
    element: (
      <AuthGuard>
        <WebLayout showNav={false} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/upload-document/',
        element: <UploadDocument />,
      },
    ],
  },

  {
    path: '/mailing-option',
    element: (
      <AuthGuard>
        <WebLayout showNav={false} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/mailing-option/',
        element: <MailingOption />,
      },
    ],
  },
  {
    path: '/time-to-mail',
    element: (
      <AuthGuard>
        <WebLayout showNav={false} children={<TimeToMail />} />
      </AuthGuard>
    ),
  },
  {
    path: '/print-jobs',
    element: (
      <AuthGuard>
        <WebLayout showNav={false} children={<PrintJobs />} />
      </AuthGuard>
    ),
  },
  {
    path: '/enhance-disputes-round',
    element: (
      <AuthGuard>
        <WebLayout showNav={true} children={<EnhanceDisputesPlan />} />
      </AuthGuard>
    ),
  },
  {
    path: '/checkout/:plan',
    element: (
      <AuthGuard>
        <WebLayout showNav={false} children={<CheckoutOnboarding showOptions={true} />} />
      </AuthGuard>
    ),
  },
  {
    path: '/checkout-disputes/:plan',
    element: (
      <AuthGuard>
        <WebLayout showNav={true} children={<CheckoutOnboarding showOptions={false} />} />
      </AuthGuard>
    ),
  },
  {
    path: '/payment-confirmation/:plan',
    element: (
      <AuthGuard>
        <WebLayout showNav={false} children={<PaymentConfirmation />} />
      </AuthGuard>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <AuthGuard>
        <WebLayout showNav={true} children={<Dashboard />} />
      </AuthGuard>
    ),
  },
  {
    path: '/setting',
    element: (
      <AuthGuard>
        <WebLayout showNav={true} children={<Setting />} />
      </AuthGuard>
    ),
  },
  {
    path: '/documents',
    element: (
      <AuthGuard>
        <WebLayout showNav={true} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/documents/',
        element: <Documents />,
      },
    ],
  },
  {
    path: '/credit-builder',
    element: (
      <AuthGuard>
        <WebLayout showNav={true} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/credit-builder/',
        element: <CreditBuilder />,
      },
    ],
  },
  {
    path: '/enhance-dispute',
    element: (
      <AuthGuard>
        <WebLayout showNav={true} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/enhance-dispute/',
        element: <EnhanceDispute />,
      },
    ],
  },
  {
    path: '/enhanced-dispute-onboarding',
    element: (
      <AuthGuard>
        <WebLayout showNav={false} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/enhanced-dispute-onboarding/',
        element: <EnhanceDisputeOnboarding />,
      },
    ],
  },
  {
    path: '/credit-report',
    element: (
      <AuthGuard>
        <WebLayout showNav={true} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/credit-report/',
        element: <CreditReport />,
      },
    ],
  },
  {
    path: '/dispute-center',
    element: (
      <AuthGuard>
        <WebLayout showNav={true} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/dispute-center/',
        element: <DisputeCenter />,
      },
    ],
  },
  {
    path: '/all-notification',
    element: (
      <AuthGuard>
        <WebLayout showNav={true} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/all-notification/',
        element: <AllNotification />,
      },
    ],
  },
  {
    path: '/all-notification',
    element: (
      <AuthGuard>
        <WebLayout showNav={true} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/all-notification/:index',
        element: <AllNotification />,
      },
    ],
  },
  {
    path: '/credit-audit',
    element: (
      <AuthGuard>
        <WebLayout
          showNav={true}
          styles={{
            main: {
              backgroundColor: '#f8f9fd',
              height: '100%',
              position: 'relative',
              backgroundImage: `url(${Background})`,
              backgroundSize: 'cover',
              backgroundPosition: 'fixed',
            },
          }}
        />
      </AuthGuard>
    ),
    children: [
      {
        path: '/credit-audit/',
        element: <CreditAudit />,
      },
    ],
  },
  {
    path: '/add-document',
    element: (
      <AuthGuard>
        <WebLayout showNav={true} />
      </AuthGuard>
    ),
    children: [
      {
        path: '/add-document/',
        element: <AddDocument />,
      },
    ],
  },
  {
    path: '/help',
    element: (
      <AuthGuard>
        <WebLayout showNav={true} children={<HelpDesk />} />
      </AuthGuard>
    ),
  },
  {
    path: '/',
    element: <AuthLayout />,
    children: [
      {
        path: '/',
        element: <SignIn />,
      },
      {
        path: 'signup',
        element: <SignUp />,
      },
      {
        path: 'reset-password/:resetId',
        element: <ResetPassword />,
      },
      {
        path: '404',
        element: <Page404 />,
      },
      {
        path: '500',
        element: <Page500 />,
      },
    ],
  },
  {
    path: '*',
    element: <AuthLayout />,
    children: [
      {
        path: '*',
        element: <Page404 />,
      },
    ],
  },
  {
    path: '/security-questions',
    element: (
      <AuthGuard>
        <WebLayout showNav={false} mainClassName='security-questions-bg' />
      </AuthGuard>
    ),
    children: [
      {
        path: '/security-questions/',
        element: <SecurityQuestions />,
      },
    ],
  },
];

export default routes;
